module.exports = __webpack_public_path__ + "static/GT-America-Compressed-Medium-Italic-f31efb8e55a3540afd21f947445bf01e.woff2";